import React from "react";
import { Button } from "carbon-components-react";
import { CalculatorCheck32 } from "@carbon/icons-react";

const Submit = ({ disabled }: { disabled: boolean }) => (
  <Button kind="primary" type="submit" renderIcon={CalculatorCheck32} disabled={disabled}>
    Run affordability
  </Button>
);

export default Submit;
